module.exports = __webpack_public_path__ + "static/media/daw-preview.6ab40cd5.png";